export default __webpack_public_path__ + "static/media/arcade-bg.2edecde6.png";